export class BaseInfoItem {
  infoLabel: string;
  value: string | number | null;
  fullWidth: boolean;
  tooltip: string | null = null;
  /** Occupies a grid cell without rendering anything, to push the next item onto a fresh row. */
  isSpacer: boolean = false;

  constructor(
    infoLabel: string,
    value: string | number | null,
    fullWidth: boolean = false,
    tooltip: string | null = null
  ) {
    this.value = value;
    this.infoLabel = infoLabel;
    this.fullWidth = fullWidth;
    this.tooltip = tooltip;
  }
}
